<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ExpertRessourcesPostureDuFormateur'
});
</script>
<template>
  <ka-container
    code="expert-ressource-5-posture-formateur"
    :data="page.$info.expertRessource5PostureFormateur">
    <!-- Ressources - Experts -->
    <ka-container code="ressources-experts">
      <!-- Titrage -->
      <ka-container code="titrage">
        <ka-text
          code="toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.toutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.titrage.toutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="posture-de-lexpert">
          <h1 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.titrage.postureDeLexpert.value', `<strong>Posture de l'expert, </strong><br><strong>formateur occasionnel</strong>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container" />
      </ka-container>
      <!-- Gauche -->
      <ka-container code="gauche">
        <ka-text code="titre">
          <h2 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.titre.value', `Coach, consultant, formateur, mentor, quel est le rôle de l’expert Matchers ? `)" />
        </ka-text>
        <ka-text code="lors-de-votre-intervention">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.lorsDeVotreIntervention.value', `Lors de votre intervention c’est avant tout comme <strong>formateur</strong> que vous serez perçu par les apprenants. Pour autant, votre intervention doit aller <strong>au-delà d’un simple déroulé pédagogique</strong>. La <a href='https://www.matchers.fr/pedagogie'><span style='color:#D93174FF;'>pédagogie Matchers</span></a> consiste à partager vos connaissances dans le flux de travail quotidien des apprenants. <br> <br>Ce modèle pédagogique nécessite de s’adapter rapidement à l’environnement de l’entreprise et <strong>s’éloigne du format classique et rigide de </strong>la <strong>plupart des formations</strong>. Effectivement, pour que cette formation soit réellement utile aux apprenants, il faudra continuellement l’orienter vers leurs questions, les observer lors des mises en situation, leur livrer vos meilleures pratiques et vos astuces… etc. `)" />
        </ka-text>
        <ka-text code="cest-a-ce-moment-la">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.cestACeMomentLa.value', `C’est à ce moment-là que vous pouvez vous demander :<br> <br><strong>Suis-je formateur ou… coach, mentor, consultant… ? </strong>Voici les limites que nous avons posées pour que vous puissiez comprendre quelle est votre position lors d'une <strong>formation</strong> <strong>Matchers</strong>.`)" />
        </ka-text>
        <ka-text code="titre-lexpert">
          <h2 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.titreLexpert.value', `L'expert Matchers un subtile mélange de 4 modèles`)" />
        </ka-text>
        <ka-text code="en-tant-quexpert">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.enTantQuexpert.value', `En tant qu'expert, vous pouvez emprunter à ces 4 modèles des méthodologie et des inspirations. Matchers expose un parfait équilibre entre ces 4 profils mais bien évidemment, en réalité tout dépendra de vos appétences, de votre personnalité et de vos forces. Tout ce que vous empruntez à ces 4 modèles doit être orienté dans un but bien précis, la transmission de compétences. `)" />
        </ka-text>
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Deux personnes engagées dans une session de formation professionnelle autour d'un ordinateur. Cette image reprend les interactions que les collaborateurs peuvent avoir entre eux à l'issue d'une formation. Un reflet de l'évolution des méthodes pédagogiques et de la synergie entre les individus et les outils numériques au service du développement professionnel.`,
            imgText: ``
          }"
          value="https://ucarecdn.com/de898a36-3041-4637-a1e2-26b768eb11e8/DéfExpertMatchers-27.svg" />
        <!-- Container -->
        <ka-container code="container-1">
          <!-- Container coach -->
          <ka-container code="container-coach">
            <ka-text code="une-part-de-coach-chez">
              <h3 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerCoach.unePartDeCoachChez.value', `Une part de coach chez l'expert Matchers `)" />
            </ka-text>
            <ka-text code="bien-que-la-regularite">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerCoach.bienQueLaRegularite.value', `Bien que <strong>la régularité des sessions de formation </strong>vous pousse à faire un suivi personnel pour chaque apprenant, vous n’intervenez pas en tant que coach. Effectivement, vous allez pouvoir pousser les apprenants à progresser, les guider et les soutenir mais les objectifs à atteindre restent pédagogiques. <strong>Le coaching implique des compétences relationnelles </strong>qui vont au-delà de la formation. Un coaching prend en considération l'individu et ses <strong>objectifs personnels comme professionnels</strong>. Contrairement à un formateur, un coach pose des questions pour aider l’individu à réfléchir, à explorer différentes perspectives et à trouver ses propres solutions. Le coaching se base sur un processus interactif de dialogue et de réflexion tandis que<strong> les formations Matchers sont dans l’action et la mise en pratique immédiate. </strong><br> <br><span style='background-color:transparent;color:#1100A2FF;'><strong>Un expert Matchers guide et pousse les apprenants comme un coach mais la dimension personnelle n’est pas un enjeu de la formation.</strong></span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container consultant -->
          <ka-container code="container-consultant">
            <ka-text code="un-expert-matchers">
              <h3 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerConsultant.unExpertMatchers.value', `Un expert Matchers <strong>n’est pas un consultant ❌</strong>`)" />
            </ka-text>
            <ka-text code="avec-votre-expertise">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerConsultant.avecVotreExpertise.value', `Avec votre expertise, <strong>vous pourriez être consultant</strong>. Vous l’êtes peut-être déjà en parallèle de votre activité. Dans une<strong> formation Matchers</strong> vous êtes, tout comme un consultant, un expert externe qui vient fournir des recommandations basées sur son expertise. En revanche, vous n’êtes là que pour <strong>guider et fournir des conseils </strong>d’après votre expérience. En aucun cas vous n’êtes décisionnaire. Un manque de résultat sur une décision que vous auriez guidée au cours de la formation ne peut vous être reprochée. Bien évidemment, le progrès et la performance sont recherchés par les apprenants mais c’est à eux de l’atteindre<strong> pendant ou à l’issue de la formation</strong>. Votre objectif est avant tout de permettre aux apprenants de<strong> monter en compétences</strong>. Dans une entreprise, l’intervention d’un consultant est motivée par le manque de compétences en interne. À l’issue de son intervention, le niveau de l’équipe reste inchangé. L’<strong>objectif d’une formation Matchers</strong> est de pouvoir rendre les apprenants autonomes sur votre sujet d’intervention. <br> <br><span style='color:#1100A2FF;'><strong>Un expert Matchers conseille les apprenants d’après son expertise mais n’intervient pas pour prendre des décisions et se substituer à l’équipe. </strong></span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container mentor -->
          <ka-container code="container-mentor">
            <ka-text code="text-1">
              <h3 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerMentor.text1.value', `Un expert Matchers <strong>n’est pas un mentor ❌</strong>`)" />
            </ka-text>
            <ka-text code="dans-le-mentorat-le">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container1.containerMentor.dansLeMentoratLe.value', `Dans le mentorat, le mentor offre souvent son expérience à une personne qui se destine à prendre un chemin similaire ou qui hésite dans ses orientations. Lors d’une<strong> formation Matchers</strong>, toutes les expériences personnelles que vous partagerez doivent toujours servir un <strong>enjeu professionnel</strong>. Vous pouvez par exemple très bien parler des pratiques de votre ancienne entreprise qui ont porté leurs fruits ou celles qui n’ont pas très bien fonctionné. <strong>Ces anecdotes nourrissent la formation </strong>car elles permettent d'imager votre expérience. Pour autant, elles n’ont pas vocation à guider les apprenants dans leurs choix personnels ou leur carrière.<br> <br><span style='color:#1100A2FF;'><strong>Un expert Matchers partage ses conseils et son expérience comme un mentor mais l’aspect de guide concernant les choix personnels des apprenants ne fait pas partie de la formation. </strong></span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="titre-description">
          <h2 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.titreDescription.value', `Description de l'expert Matchers`)" />
        </ka-text>
        <ka-text code="text-2">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.text2.value', `<strong>Un expert Matchers est un formateur occasionnel </strong>expert dans son domaine. Il est doté d’une grande <strong>capacité d’adaptation</strong>. Avec aisance, il partage ses connaissances et accompagne la progression des apprenants dans leur travail quotidien. <strong>Il guide et oriente la formation</strong> en fonction des besoins des apprenants et met à leur service son expérience, avant tout, pratique. `)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-exemples">
          <!-- Container -->
          <ka-container code="container-2">
            <!-- Container -->
            <ka-container code="container-3">
              <ka-text code="✅">
                <h1 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.containerExemples.container2.container3.✅.value', `<strong>✅</strong>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="partager-ses-connaissances">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.containerExemples.container2.partagerSesConnaissances.value', `- Partager ses connaissances de façon structurée<br> <br>- Montrer et faire faire<br> <br>- Conseiller et guider`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-4">
            <!-- Container -->
            <ka-container code="container-5">
              <ka-text code="❌">
                <h1 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.containerExemples.container4.container5.❌.value', `❌`)" />
              </ka-text>
            </ka-container>
            <ka-text code="faire-a-la-place">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.containerExemples.container4.faireALaPlace.value', `- Faire à la place des apprenants [en aucun l’entreprise ne doit vous sous-traiter son travail]<br> <br>- Imposer des outils<br> <br>- Devenir décisionnaire`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="k-4-etapes-posture">
          <h2 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.k4EtapesPosture.value', `Posture au cours des échanges`)" />
        </ka-text>
        <ka-text code="au-cours-des-echanges">
          <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.auCoursDesEchanges.value', `Au cours des échanges vous allez basculer de la <strong>position haute </strong>à la <strong>position basse </strong>et inversement. La position basse place l’expert comme celui “qui ne sait pas”. <strong>Il questionne et reformule</strong>. La position haute quant à elle, positionne l’expert comme LA personne de référence. Cette position vous pousse à adopter un comportement confiant pour livrer votre savoir avec assurance.<br> <br><strong>Votre posture de formateur </strong>vous poussera à<strong> </strong>passer de l’une à l’autre pour <strong>rester à l'écoute des apprenants tout en délivrant votre expertise avec fermeté.</strong>`)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-6">
          <!-- Container -->
          <ka-container code="container-7">
            <!-- Container -->
            <ka-container code="container-8">
              <ka-text code="position-basse">
                <h1 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container6.container7.container8.positionBasse.value', `<strong>Position basse</strong><br>👉 <strong>Interrogation </strong>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="curiosite-habilite">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container6.container7.curiositeHabilite.value', `<ul><li>Curiosité</li><li>Habilité</li><li>Analyse</li><li>Écoute</li><li>Humilité</li><li>Flexibilité</li><li>Patience</li></ul>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-9">
            <!-- Container -->
            <ka-container code="container-10">
              <ka-text code="position-haute">
                <h1 v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container6.container9.container10.positionHaute.value', `<strong>Position haute</strong><br>👉 <strong>Affirmation</strong>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="competence-technique">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.gauche.container6.container9.competenceTechnique.value', `<ul><li>Compétence technique</li><li>Expertise</li><li>Assurance</li><li>Énergie</li><li>Engagement</li><li>Leadership</li><li>Charisme</li></ul>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Droite -->
      <ka-container code="droite">
        <!-- Container -->
        <ka-container
          code="container-11"
          :xs="{ hidden: null }">
          <ka-text code="text-3">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.text3.value', `<strong>Sommaire :</strong>`)" />
          </ka-text>
          <ka-text code="text-4">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.text4.value', `<ul><li><strong>Coach, consultant, formateur, mentor, quel est le rôle de l’expert Matchers ? </strong></li></ul>`)" />
          </ka-text>
          <!-- Container -->
          <ka-container
            code="container-12"
            :options="{ click: page.container12Click }">
            <ka-text code="text-5">
              <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.container12.text5.value', `<ul><li><strong>Ce qu'un expert Matchers n'est pas</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icone-dev-up"
              :options="{
                click: page.iconeDevUpClick,
                $state: { selected: $isEqual(page.$elements['k-4-etapes-txt']?.style.hidden, page.$constants.k4EtapesTxtHidden) }
              }"
              :selected="{ click: page.iconeDevUpClickWhenSelected }"
              value="i-fa-solid:angle-down" />
          </ka-container>
          <ka-text
            code="k-4-etapes-txt"
            :options="{ hidden: null }">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.k4EtapesTxt.value', `<span style='color:#999999FF;'>1 - Un expert Matchers n’est pas un coach ❌<br>2 - Un expert Matchers n’est pas un consultant ❌<br>3 - Un expert Matchers n’est pas un mentor ❌</span>`)" />
          </ka-text>
          <ka-text code="text-6">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.text6.value', `<ul><li>Description de l'expert Matchers</li></ul>`)" />
          </ka-text>
          <ka-text code="text-7">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container11.text7.value', `<ul><li>Posture de l'expert au cours des échanges</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-13">
          <ka-text code="text-8">
            <span v-html="t('expertRessource5PostureFormateur.ressourcesExperts.droite.container13.text8.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="preview-ressource-short--p120"
            title="<strong>Animer la formation</strong>"
            image="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-1--p120"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.element1Click
            }"
            title="<strong>Comment créer mon support de formation ?</strong>"
            image="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-2--p120"
            :options="{
              href: { name: `hub-expert-Ressources-preparer-rdv-decouverte` },
              click: page.element2Click
            }" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-3--p120"
            :options="{
              href: { name: `hub-expert-Ressources-rediger-programme-de-formation` },
              click: page.element3Click
            }"
            title="<strong>Comment rédiger un programme de formation ?</strong>"
            image="https://ucarecdn.com/d94a0c66-9322-47b8-afc4-5d0d564e6da8/" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { expertRessourcesPostureDuFormateur } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p120')
const appData = appDataStore()
const page = expertRessourcesPostureDuFormateur()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
